import ThrottledApi from './api/throttledApi';
import { AxiosResponse } from 'axios';

// ===== GET OPERATIONS =====

// Get Stripe products - used in addStore and getSubscription
export const getStripeProducts = async () => {
  console.log('💳 StripeService: Getting Stripe products');
  try {
    const response = await ThrottledApi.get('/v1/stripe/products') as AxiosResponse;
    
    console.log('💳 StripeService: Stripe products retrieved successfully');
    return {
      success: true,
      data: response.data,
      error: null
    };
  } catch (error: any) {
    console.log('💳 StripeService: Stripe products retrieval failed:', error);
    return {
      success: false,
      data: null,
      error: error.response?.data || error.message
    };
  }
};

// ===== POST OPERATIONS (ACTUALLY USED) =====

// Create checkout session - used in addStore and getSubscription
export const createCheckoutSession = async (data: any) => {
  console.log('💳 StripeService: Creating checkout session with data:', data);
  try {
    const response = await ThrottledApi.post('/v1/stripe/create-checkout-session', data) as AxiosResponse;
    
    console.log('💳 StripeService: Checkout session created successfully');
    return {
      success: true,
      data: response.data,
      error: null
    };
  } catch (error: any) {
    console.log('💳 StripeService: Checkout session creation failed:', error);
    return {
      success: false,
      data: null,
      error: error.response?.data || error.message
    };
  }
};

// Create portal session - used in store pages
export const createPortalSession = async (data: any) => {
  console.log('💳 StripeService: Creating portal session with data:', data);
  try {
    const response = await ThrottledApi.post('/v1/stripe/create-portal-session', data) as AxiosResponse;
    
    console.log('💳 StripeService: Portal session created successfully');
    return {
      success: true,
      data: response.data,
      error: null
    };
  } catch (error: any) {
    console.log('💳 StripeService: Portal session creation failed:', error);
    return {
      success: false,
      data: null,
      error: error.response?.data || error.message
    };
  }
};

export const changeTrialSubscriptionPlan = async (data: any) => {
  console.log('💳 StripeService: Changing trial subscription plan with data:', data);
  try {
    const response = await ThrottledApi.post('/v1/stripe/trial-subscription/change-plan', data) as AxiosResponse;

    console.log('💳 StripeService: Trial subscription plan changed successfully');
    return {
      success: true,
      data: response.data,
      error: null
    };
  } catch (error: any) {
    console.log('💳 StripeService: Trial subscription plan change failed:', error);
    return {
      success: false,
      data: null,
      error: error.response?.data || error.message
    };
  }
};

export const cancelTrialSubscriptionAtTrialEnd = async (data: any) => {
  console.log('💳 StripeService: Scheduling trial subscription cancellation with data:', data);
  try {
    const response = await ThrottledApi.post('/v1/stripe/trial-subscription/cancel-at-trial-end', data) as AxiosResponse;

    console.log('💳 StripeService: Trial subscription cancellation scheduled successfully');
    return {
      success: true,
      data: response.data,
      error: null
    };
  } catch (error: any) {
    console.log('💳 StripeService: Trial subscription cancellation failed:', error);
    return {
      success: false,
      data: null,
      error: error.response?.data || error.message
    };
  }
};

export const getCheckoutSessionSummary = async (sessionId: string) => {
  try {
    const response = await ThrottledApi.get('/v1/stripe/checkout-session-summary', {
      params: { session_id: sessionId }
    }) as AxiosResponse;

    return {
      success: true,
      data: response.data,
      error: null
    };
  } catch (error: any) {
    return {
      success: false,
      data: null,
      error: error.response?.data || error.message
    };
  }
};

// ===== BACKWARD COMPATIBILITY ALIASES =====

// Alias for getStripeProducts
export const getProduct = async () => {
  return getStripeProducts();
};

// Export all stripe functions as a single object for convenience
export const stripeService = {
  getStripeProducts,
  createCheckoutSession,
  createPortalSession,
  changeTrialSubscriptionPlan,
  cancelTrialSubscriptionAtTrialEnd,
  getCheckoutSessionSummary,
  getProduct
};

export default stripeService; 
